export const VERTEX_SHADER = 'vs';
export const FRAGMENT_SHADER = 'fs';
//# sourceMappingURL=constants.js.map